import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './CTASection.css';

const CTASection = () => {
  const [title, setTitle] = useState('Ready to Transform Your Attendance Management?');
  const [subtitle, setSubtitle] = useState('Join thousands of organizations already using Haazri');
  const [buttonText, setButtonText] = useState('Start Free Trial');
  const [buttonLink, setButtonLink] = useState('/haazri-frontend/#/register');

  useEffect(() => {
    fetchCTA();
  }, []);

  const fetchCTA = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const sections = response.data.data.sections || [];
        const ctaSection = sections.find(s => s.section_key === 'cta');

        if (ctaSection && ctaSection.content) {
          const titleContent = ctaSection.content.find(c => c.content_key === 'cta_title');
          const subtitleContent = ctaSection.content.find(c => c.content_key === 'cta_subtitle');
          const buttonTextContent = ctaSection.content.find(c => c.content_key === 'cta_button_text');
          const buttonLinkContent = ctaSection.content.find(c => c.content_key === 'cta_button_link');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);
          if (buttonTextContent) setButtonText(buttonTextContent.content_value);
          if (buttonLinkContent) setButtonLink(buttonLinkContent.content_value);
        }
      }
    } catch (error) {
      console.error('Failed to fetch CTA:', error);
    }
  };

  return (
    <section className="cta-section">
      <div className="container">
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <a href={buttonLink} className="btn btn-primary cta-button">
          {buttonText}
        </a>
      </div>
    </section>
  );
};

export default CTASection;
